import { gql } from "apollo-boost"

export default gql`
  fragment DivisionFragment on Division {
    id
    title
  }
`